import { mapGetters } from 'vuex';

import bus from '@/utils/bus';

export default {
  name: 'Header',
  data() {
    return {
      duration: 3000,
      itemInfos: {},
      showItem: false,
      tempCompany: '',
      timer: null,
    };
  },
  props: {
    menuOpened: {
      default: false,
      type: Boolean,
    },
    showCartButton: {
      default: false,
      type: Boolean,
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  created() {
    bus.$on('TEMP_COMPANY_NAME', (name) => {
      if (name) {
        this.tempCompany = name;
      }
    });
    bus.$on('CLEAR_TEMP_COMPANY_NAME', () => {
      this.tempCompany = '';
    });
    bus.$on('SHOW_ADD_TO_CART_ITEM', ({
      count,
      name,
      note,
      price,
    }) => {
      this.showItem = true;
      this.itemInfos = {
        count,
        name,
        note,
        price,
      };
      clearTimeout(this.timer);
      this.startTimer();
    });
  },
  computed: {
    ...mapGetters('cart', [
      'cartItemsCount',
    ]),
    ...mapGetters('user', [
      'isAuthenticated',
    ]),
    company() {
      return localStorage.getItem('team_name') || '';
    },
  },
  methods: {
    startTimer() {
      this.timer = setTimeout(() => {
        this.showItem = false;
      }, this.duration);
    },
  },
};
